import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Plumbing-Works2.jpg';
import { Helmet } from 'react-helmet';

const Plumbingwork = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

     <>
      <Helmet>
        <title>Plumbing Works</title>
        <meta name="description" content="Professional Plumbing That Flows Right" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

               

                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Plumbing Works</h1>
                                <h6>Professional Plumbing That Flows Right</h6>
                                <p>
                             Whether it’s a new construction, a bathroom renovation, or fixing plumbing issues,
                              we provide end-to-end plumbing services with experienced technicians.
                                </p>
                                <h4>Plumbing services include :</h4>
                                <ul>
                                    <li>New pipeline installation</li>
                                    <li>Bathroom/kitchen fittings</li>
                                    <li>Leakage detection and repair</li>
                                    <li>Water tank and motor connections</li>
                                    <li>Sanitary ware installation</li>
                                    <p>Our prompt and professional team ensures minimal disruption and maximum reliability.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>


                     <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>
                    
                
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Plumbingwork ;